import types from 'constants/actionTypes';

import { combineReducers } from 'redux';
 
const initialState = {

  byId: {},

  indexIds: [],

};
 
const byId = (state, { type, payload }) => {

  if (typeof state === 'undefined') {

    return initialState.byId;

  }
 
  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS: {

      const bodyStyles = payload?.entities?.bodyStyles;

      if (bodyStyles) {

        return { ...state, ...bodyStyles };

      } else {

        sessionStorage.setItem('Missing bodyStyles in payload.entities', payload);

        return state;

      }

    }
 
    default:

      return state;

  }

};
 
const indexIds = (state, { type, payload }) => {

  if (typeof state === 'undefined') {

    return initialState.indexIds;

  }
 
  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS: {

      const resultBodyStyles = payload?.result?.bodyStyles;

      if (Array.isArray(resultBodyStyles)) {

        return resultBodyStyles;

      } else {

        sessionStorage.setItem('Missing result.bodyStyles in payload', payload);

        return state;

      }

    }
 
    default:

      return state;

  }

};
 
export default combineReducers({

  byId,

  indexIds,

});

 
